// DOM Ready
$(function() {

    $('form[name="form"]').slick();
    $('.background_slider').slick({
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: false,
        adaptiveHeight: false,
        autoplay: true,
        autoplaySpeed: 2000,
        cssEase: 'linear',
        pauseOnFocus: false,
        pauseOnHover: false
    });

    var acc = document.getElementsByClassName("product-accordion");
    var i;

    for (i = 0; i < acc.length; i++) {
        acc[i].addEventListener("click", function() {
            /* Toggle between adding and removing the "active" class,
            to highlight the button that controls the panel */
            this.classList.toggle("active");

            /* Toggle between hiding and showing the active panel */
            var panel = this.nextElementSibling;
            if (panel.style.display === "block") {
                panel.style.display = "none";
            } else {
                panel.style.display = "block";
            }
        });
    }
    $('.flex-direction-nav li a').on("click",function(){
            var active_iamge = jQuery('.flex-control-nav img.flex-active' );
            if(active_iamge.length>0){
                console.log(active_iamge.position().left);
                $('.flex-control-nav').animate({scrollLeft: active_iamge.position().left});
            }
       
        
    });
    $('.flex-control-nav li').on("click",function(){
        
        var active_iamge = jQuery(this);
        console.log(active_iamge);
        if(active_iamge.length>0){
            console.log(active_iamge.position().left);
            $('.flex-control-nav').animate({scrollLeft: active_iamge.position().left});
        }
    });

    $('.attribute-selector .attribute-selector__form').on('submit', function(e){
        e.preventDefault();        
        submitAttributeSelectorForm();
    });

    function submitAttributeSelectorForm(){

        var form = $('.attribute-selector .attribute-selector__form');
        data = form.serializeArray();        

        $.post(ajax_object.ajax_url, data,
            function(data) {
                                
                $('#attribute-selector-results').html(data.data.html);                
                
                form.find('input[name="paged"]').val(1);

                if(page = data.data.paged){ 
                    form.find('input[name="paged"]').val(parseInt(page));
                }                
 
            }, 
        'json'); 
    }

    $('document,body').on('click','#attribute-selector-results button', function(){

        if($(this).hasClass('.button--prev')){
            form.find('input[name="paged"]').val(form.find('input[name="paged"]').val()-1);
        }
        
        submitAttributeSelectorForm();
    }); 

    if(typeof popup_timeout !== "undefined"){
        setTimeout(showPopup, popup_timeout * 1000);
    }

    $('#form-popup-close').click(function(){
        closePopup();
    });
    $('#popup_bkg').click(function(){
        closePopup();
    });

    fixSliderStyle();

    $('body.home .testimonialSlider').on('click', function (e){
        location.href="./about-us/case-studies/";
    })
    $('body.page-id-456 .testimonialSlider').on('click', function (e){
        location.href="../about-us/case-studies/";
    })

    $('.magnifier_icon').on("click", function(e){
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        $(e.target).parent().find('img').click();
    });

    $('.footer-widgets.column-seventh .widget-title').on('click', function(){
        location.href = "../../../../contact-us/";
    });

    if($('body').hasClass('home')){
        checkSliderMobile();
        $(window).resize(function() {
            checkSliderMobile();
        });
    }

    document.addEventListener( 'wpcf7submit', function( event ) {
        var form = event.target;
        var wrapper = $(form).closest('.pum-content');
        $(wrapper).animate({
            scrollTop: $(wrapper).height()
        }, 2000);
    }, false );
});

function checkSliderMobile(){
    var viewportWidth = $(window).width();
    if(viewportWidth < 1280){
        var diff = 1280 - viewportWidth;
        var partial = (diff * 0.1) + (0.0001 * diff*diff);
        var tot = 60 + partial;
        var value = -tot+"vw";
        $('.hero-wrap .background_slider .slick-track [data-slick-index=\'0\'] img').css('marginLeft', value);
    }else{
        $('.hero-wrap .background_slider .slick-track [data-slick-index=\'0\'] img').css('marginLeft', 'auto');
    }
}

function fixSliderStyle(){
    $('.testimonialSlider .slick-prev').html("<img src='../content/themes/twentytwenty-enviroquip/images/arrow-left.png'>");
    $('.testimonialSlider .slick-next').html("<img src='../content/themes/twentytwenty-enviroquip/images/arrow-right.png'>");
}

function closePopup(){
    $("#popup_wrapper").hide();
    $("#popup_bkg").hide();
    setCookie("showPopup", "false", 365);
}

function showPopup(){
    var test = getCookie("showPopup")
    if(test !== "false") {
        $('#popup_bkg').show();
        $('#popup_wrapper').show();

        //center popup
        var left = Math.round(($('#popup_bkg').width() - $('#popup_wrapper').width()) / 2);
        var top = Math.round(($('#popup_bkg').height() - $('#popup_wrapper').height()) / 2);
        $('#popup_wrapper').css("left", left+"px");
        $('#popup_wrapper').css("top", top+"px");
    }
}


function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
